export default defineNuxtRouteMiddleware((to, from) => {
  if (!from.name) {
    const id = 'id' in to.params ? to.params.id : undefined
    return navigateTo(id === 'bulk' ? '/policies' : `/policies/${id}`, {
      replace: true,
    })
  }
})
